// extracted by mini-css-extract-plugin
module.exports = {"label":"Input_label__3WueG","boxInput":"Input_boxInput__2VR-p","input":"Input_input__3dDXF"};